import { convertArrayToObject } from '@root/common/utils/helpers';
import { RawArticle, GetArticleByID } from '@root/modules/article/types/getArticleByID';

type Article = GetArticleByID['data']['article']['data'][0];

function unifyAuthorObjects(authors: RawArticle['authors'], lang: string | undefined): Article['authors'] {
  const articleAuthors = authors.items.map((author) => {
    if (author.typename === 'ArticleAuthorFromAuthor') {
      author.attributes = convertArrayToObject<RawArticle['authors']['items'][0]>(author.authorAttributes, {});
      const key = lang === 'RU' ? 'positionRu' : 'position';
      author.attributes.description = author?.attributes[key];
    } else if (author.typename === 'ArticleAuthorFromEmployee') {
      author.attributes = author.attributes ?? {};
      author.attributes.email = author.email;
    }

    return author;
  });

  return {
    items: articleAuthors,
  };
}

export default unifyAuthorObjects;
